import { fetcher } from "helpers/fetcher";

import {
  TDeleteBusinessEstablishmentReq,
  TDeleteBusinessEstablishmentRes,
} from "./types";
import { API_HEADER } from "../constants";
import { ENDPOINT } from "../endpoint";

export const deleteBusinessEstablishment = async (
  payload: TDeleteBusinessEstablishmentReq
) => {
  return await fetcher<
    TDeleteBusinessEstablishmentRes,
    TDeleteBusinessEstablishmentReq["data"]
  >(ENDPOINT.CORPORATION.DELETE_BUSINESS_ESTABLISHMENT, {
    data: payload.data,
    headers: {
      [API_HEADER.VERSION]:
        ENDPOINT.CORPORATION.DELETE_BUSINESS_ESTABLISHMENT.version,
      [API_HEADER.CORP_ID]: payload?.idCorp,
    },
  });
};

export const mutationDeleteBusinessEstablishment = async (
  payload: TDeleteBusinessEstablishmentReq
) => {
  return (await deleteBusinessEstablishment(payload)).data;
};

mutationDeleteBusinessEstablishment._key = (
  payload: TDeleteBusinessEstablishmentReq
) => [ENDPOINT.CORPORATION.DELETE_BUSINESS_ESTABLISHMENT.url, payload];
